import { render, staticRenderFns } from "./DraftOverlay.vue?vue&type=template&id=2f687126&"
import script from "./DraftOverlay.vue?vue&type=script&lang=js&"
export * from "./DraftOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports